


























































import {Component, Vue} from 'vue-property-decorator'
import Login from '@/components/Login.vue'
import firebase from 'firebase/app'
import 'firebase/firestore'
import SettingUser from '@/components/SettingUser.vue'
import {DB} from '@/enum/db'

@Component({
  components: {SettingUser, Login},
})
export default class App extends Vue {
  private loginDialog = false
  private editDialog = false
  private isDarkMode = false
  private menu = false

  private created() {
    this.isDarkMode = window.localStorage.darkMode === 'true'

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.commit('setUser', user)
        firebase.firestore().collection(DB.userdata).doc(user.uid).onSnapshot((snapshot) => {
          if (snapshot.exists) {
            this.$store.commit('setUserData', snapshot.data())
          }
        })
      } else {
        this.$store.commit('setUser', null)
        this.$store.commit('setUserData', null)
      }
    })
  }

  private showLogin() {
    this.loginDialog = true
  }

  private toggleMode() {
    this.isDarkMode = !this.isDarkMode
    window.localStorage.setItem('darkMode', this.isDarkMode.toString())
  }

  private logout() {
    firebase.auth().signOut()
    location.reload()
  }
}
